import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { has, get } from 'lodash';


// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-dropdowns--dropdowns

const DropDown = styled.div`
  width: auto;
  position: relative;
`;

const DropDownSelect = styled.div`
width: 100%;
position: relative;
`;

//  span {
//     font-family: 'Inter';
//     font-style: normal;
//     font-weight: 400;
//     font-size: 16px;
//     line-height: 24px;
//     color: #9ba1aa;
//     color:${(props) => (props.hasSelected ? '#101828' : '#667085')} ;
//     width: 100%;
//     height: 100%;
//     background: red;
//     text-align:left;
//     display: inline-block;
//   }

const DropDownHead = styled.div`
  height: 44px;
  background: #ffffff;
  border: ${(props) =>
    (props.isOpen ? '1px solid #0094FB' : '1px solid #99B2C6')};
  border-radius: 8px;
  width: 100%;
  position: relative;
  padding-left: 0.6em;
  font-family: ${(props) => (props.hasSelected ? 'Inter' : 'Quicksand')};
  font-style: normal;
  font-weight:  ${(props) => (props.hasSelected ? '400' : '600')};
  font-size: 16px;
  line-height: 44px;
  color: #9ba1aa;
  color:${(props) => (props.hasSelected ? '#101828' : '#809FB8')} ;
  text-align:left;

  i::before {
    color: #667085;
    position: absolute;
    top: 50%;
    right: 1em;
    transform: translateY(-50%);
  }
  :hover {
    border: 1px solid #0094FB;
  }
`;

const DropDownContent = styled.ul`
  position: absolute;
  top: calc(44px + 1em);
  left: 0;
  z-index: 1001;
  width: 100%;
  border: 1px solid #F2F4F7;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  border-radius: 8px;
  background: #fff;
  list-style-type: none;
  padding: 0;
  overflow: hidden;
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;

const DropDownItem = styled.li`
  height: 44px;
  font-family: 'Inter'
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 44px;
  color: #101828;
  padding-left: 0.6em;
  text-align:left;
  position: relative;
  background: ${(props) => (props.selected ? '#F9FAFB' : '#fff')};

  :hover {
    background: #F9FAFB;
    color: #0090ff;
  }
  i {
    color: ${(props) => (props.selected ? '#0094FB' : '#fff')};
    position: absolute;
    right: 0.6em;
    top: 50%;
    transform: translateY(-50%);
  }
  :hover i {
    color: #0094FB;
  }
`;

const HintText = styled.small`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #667085;
`;

const ErrorText = styled(HintText)`
  color: #F04438;
`;

const StyledLabel = styled.label`
&&&& {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #384455 !important;
}
`;

// const FieldTitle = styled.span`
//   padding: 0.4em;
//   font-weight: 600;
//   font-size: 14px;
//   line-height: 17px;
//   color: #333333;
// `;

export const Dropdown = ({
  field, form: {
    setFieldValue,
    values,
    touched,
    errors,
    setTouched
  }, otherProps
}) => {
  const {
    id,
    listItems,
    // selected,
    isDropped,
    placeholder
  } = otherProps;
  const [isOpen, setIsOpen] = useState(isDropped || false);
  const [headItem, setHeadItem] = useState(get(values, `${field.name}`) ? get(values, `${field.name}`) : null);
  const [hasSelected, setHasSelected] = useState(!!get(values, `${field.name}`));
  const hasError = has(touched, field.name) && has(errors, field.name);

  // const [value, setValue] = useState(isEmpty(get(values, `${field.name}`)) ? '' : get(values, `${field.name}`));

  const setItemAndClose = (item) => {
    if (!has(touched, field.name)) {
      setTouched({
        ...touched,
        [field.name]: true
      });
    }
    if (item.value === headItem) {
      setHeadItem(null);
      setFieldValue(field.name, '');
      setHasSelected(false);
    } else {
      setHeadItem(item.value);
      setFieldValue(field.name, item.value);
      setHasSelected(true);
    }
    setIsOpen(false);
  };

  return (
    <Fragment>
      {otherProps.label &&
        // <FieldTitle>{otherProps.label}</FieldTitle>
        <StyledLabel>{otherProps.label}</StyledLabel>
      }
      <DropDown>
        <DropDownHead
          id={id} onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}
          hasSelected={hasSelected}
        >
          {headItem || placeholder}
          <Icon name={isOpen ? 'angle up' : 'angle down'} />
        </DropDownHead>
        <DropDownContent isOpen={isOpen}>
          {listItems.map((item) => (
            <DropDownItem
              key={item.value}
              onClick={() => setItemAndClose(item)}
              selected={headItem === item.value}
            >
              {item.content}
              <Icon name='checkmark' size='small' selected={headItem === item} />
            </DropDownItem>
          ))}
        </DropDownContent>
      </DropDown>
      {
        hasError && (
          <ErrorText>{errors[field.name]}</ErrorText>
        )
      }
    </Fragment>
  );
};

// DropDown.defaultProps = {
//   listItems: ['Groups', 'Themes', 'Other options'],
//   selected: 'Other options',
//   isDropped: true
// };

export const DropdownSelect = ({
  options, isDropped, onChange, value
}) => {
  const [isOpen, setIsOpen] = useState(isDropped || false);

  const headItem = () => {
    // eslint-disable-next-line array-callback-return
    const head = options.map((option) => {
      if (option.value === value) {
        return option.text;
      }
    });
    return head;
  };

  const ClickEvent = (e, option) => {
    onChange(e, option);
    setIsOpen(false);
  };

  return (
    <DropDownSelect>
      <DropDownHead onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        {
          value ? headItem()
            : options[0].text
        }
        {/* <Icon name='angle down' /> */}
        <Icon name={isOpen ? 'angle up' : 'angle down'} />
      </DropDownHead>
      <DropDownContent isOpen={isOpen}>
        {options.map((option) => (
          <DropDownItem
            key={option.key}
            onClick={(e) => ClickEvent(e, option)}
            selected={value === option.value}
          >
            {option.text}
            <Icon name='checkmark' size='small' selected={value === option.value} />
          </DropDownItem>
        ))}
      </DropDownContent>
    </DropDownSelect>
  );
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/dropdown.js